<template>
  <b-col md="3" xs="12" sm="12" class="mainTemperatureComponent">
    <b-button class="search-location" v-b-toggle.location>Search for Places</b-button>

    <b-sidebar width="27rem" no-header id="location" shadow v-slot:default="{ hide }">
      <button @click="hide" type="button" aria-label="Close" class="close text-light">
        <svg viewBox="0 0 16 16" width="1.5em" height="2em" focusable="false" role="img"
          xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-x b-icon bi">
          <g>
            <path fill-rule="evenodd"
              d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
            <path fill-rule="evenodd"
              d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
          </g>
        </svg>
      </button>
      <LocationSidebar @citychange="$emit('citychange', $event)" />
    </b-sidebar>

    <b-card-img-lazy
      :src="require('./../assets/icons/Cloud-background.png')"
      alt="Cloud Background"
      class="rounded-0 cloudBg"
    ></b-card-img-lazy>

    <b-card-img-lazy
      center
      :src="getWeatherIcon"
      alt="Weather Icon"
      class="rounded-0 weatherIcon"
    ></b-card-img-lazy>

    <div class="temperatureHolder" v-if="weatherData && weatherData.main && weatherData.main.temp">
      <h1 class="temperature">
         {{ displayTemp }}<span class="degree">°{{ unit === 'metric' ? 'C' : 'F' }}</span>
      </h1>
    </div>

    <div class="weatherStatus" v-if="weatherData && weatherData.weather && weatherData.weather[0]">
      <h2 class="weatherStatusText">
        {{ weatherData.weather[0].description }}
      </h2>
    </div>

    <div class="date">
      <p :style="{ fontSize: '18px' }">Today • {{ dateBuilder() }}</p>
    </div>

    <div class="city" v-if="weatherData && weatherData.name">
      <p :style="{ fontSize: '18px' }">{{ weatherData.name }}, {{ weatherData.country || '' }}</p>
    </div>
  </b-col>
</template>

<script>
import LocationSidebar from "./LocationSidebar";

export default {
  name: "MainTemperatureComponent",
  components: {
    LocationSidebar,
  },
  props: {
    weatherData: { type: Object },
    dateBuilder: { type: Function },
    unit: { type: String },
  },
  computed: {
    getWeatherIcon() {
      if (
        !this.weatherData ||
        !this.weatherData.weather ||
        !this.weatherData.weather[0]
      ) {
        return require(`./../assets/icons/Cloud-background.png`);
      }

      const weatherMain = this.weatherData.weather[0].main;
      const weatherDesc = this.weatherData.weather[0].description;

      const mapping = {
        Clear: "Clear.png",
        Clouds: "Light Cloud.png",
        Rain: "Light Rain.png",
        Drizzle: "Light Rain.png",
        Thunderstorm: "Thunderstorm.png",
        Snow: "Snow.png",
        Mist: "Cloud-background.png",
        Haze: "Cloud-background.png",
        Fog: "Cloud-background.png",
        Smoke: "Cloud-background.png",
        Dust: "Cloud-background.png",
        Sleet: "Sleet.png",
        ShowerRain: "Showers.png",
      };

      let iconFile = mapping[weatherMain];

      if (!iconFile) {
        if (weatherDesc.includes("shower")) {
          iconFile = "Showers.png";
        } else if (weatherDesc.includes("heavy rain")) {
          iconFile = "Heavy Rain.png";
        } else if (weatherDesc.includes("light rain")) {
          iconFile = "Light Rain.png";
        } else if (weatherDesc.includes("cloud")) {
          iconFile = "Heavy Cloud.png";
        } else {
          iconFile = "Cloud-background.png";
        }
      }

      try {
        return require(`./../assets/icons/${iconFile}`);
      } catch (err) {
        console.warn("Icon not found, fallback", iconFile, err);
        return require(`./../assets/icons/Cloud-background.png`);
      }
    },
    displayTemp() {
      if (!this.weatherData || !this.weatherData.main) return '--';

      return Math.round(this.weatherData.main.temp);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/mainTemperatureComponent.scss";
</style>